import React from 'react';
import '../styles/animation.css';

const Animation = () => {
  return (
    <div className="ocean">
      <div className="wave"></div>
      <div className="wave"></div>
    </div>
  );
};

export default Animation;
